import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="product-section">
      <div className="hero-section">
        <h1>零股玩家的最佳夥伴</h1>
        <p className="subtitle">輕鬆管理股東會投票與零股交易</p>
        <p className="description">
          自動化服務讓您無需煩惱繁瑣操作，從股東會投票到零股買賣與減資
          處理，全面提升效率、減少損失。
        </p>
        <button className="contact-button" onClick={() => navigate('/about')}>Contact us</button>
      </div>

      <div className="feature-section">
        <div className="feature-content">
          <h2><center>EzVote</center></h2>
          <p className="feature-subtitle"><strong>節省時間，提升效率，精準執行</strong></p>
          <p className="feature-description">
            面對每年高達700場股東會，傳統人工投票不僅耗時，還容易出現錯誤。
            我們的自動股東會投票程式專為零股玩家設計，幫助您輕鬆完成以下任務：
          </p>
          <ul className="feature-list">
            <li><strong>全自動投票：</strong>一次設定，所有帳號即可自動參與股東會投票。</li>
            <li><strong>表決單導出：</strong>支援6種列印格式，隨時輕鬆列印或匯出表決單。</li>
            <li><strong>高效運行：</strong>節省資費時間，讓程式為您代勞，提升工作效率。</li>
          </ul>
          <div className="button-container">
            <button className="learn-more" onClick={() => navigate('/feature')}>Learn More</button>
          </div>
        </div>
        {/* <div className="feature-image">
          <img src="/product-image.jpg" alt="自動投票系統" />
        </div> */}
      </div>

      <div className="feature-section">
        {/* <div className="feature-content">
          <h2><center>EzStock</center></h2>
          <p className="feature-subtitle"><strong>輕鬆管理零股，減少虧損，提升效率</strong></p>
          <p className="feature-description">
            擁有數個帳戶的您，每年處理高達700家公司的零股交易，繁瑣且耗時。
            我們的自動化程式專為零股交易設計，提供以下優勢：
          </p>
          <ul className="feature-list">
            <li><strong>自動化零股買賣：</strong>一件設定，自動完成零股買進，省時省力。</li>
            <li><strong>減資自動處理：</strong>自動識別減資並賣出零股，避免股權損失。</li>
            <li><strong>高效管理多帳戶：</strong>支援大規模帳戶操作，提升管理效率。</li>
          </ul>
          <div className="button-container">
            <button className="learn-more">Learn More</button>
          </div>
        </div> */}
        {/* <div className="feature-image">
          <img src="/product-image.jpg" alt="自動零股買賣系統" />
        </div> */}

      </div>
    </div>
  );
};

export default Home; 